import {
  Form,
  Space,
} from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { addBenefit } from '../../services/benefitServices';
import BenefitForm from '../../forms/BenefitForm';

function AddBenefit() {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [errors, setErrors] = useState();
  const [fileList, setFileList] = useState();

  const handleSubmit = async (values) => {
    try {
      const formData = new FormData();
      Object.keys(values).forEach((key) => {
        if (key === 'image' && values[key]?.file) {
          formData.append(key, values[key].file);
        } else {
          // eslint-disable-next-line no-unused-expressions
          values[key] && formData.append(key, values[key]);
        }
      });
      const res = await addBenefit(formData);
      if (res.status === 'success') {
        navigate('/admin/benefits');
      }
    } catch (e) {
      setErrors(e?.response?.data?.errors);
    }
  };

  return (
    <Space size="large" direction="vertical" style={{ width: '100%' }}>
      <ArrowLeftOutlined
        style={{ fontSize: '20px' }}
        onClick={() => navigate('/admin/benefits')}
      />
      <BenefitForm
        form={form}
        handleSubmit={handleSubmit}
        errors={errors}
        fileList={fileList}
        setFileList={setFileList}
      />
    </Space>
  );
}
export default AddBenefit;
